import clsx from "clsx";
import { useTheme } from "../../../context/ThemeContext";
import { useEffect, useState } from "react";
import useCategories from "../../../hooks/useCategories";
import useAxios from "../../../hooks/useAxios"; // [NUEVO] Importamos useAxios
import { Dropdown } from "react-bootstrap";
import { FaArrowDown, FaArrowUp } from "react-icons/fa";
import { MdDashboard } from "react-icons/md";

const orderByObject = {
    'name,ASC': 'Nombre A-Z',
    'name,DESC': 'Nombre Z-A',
    'code,ASC': 'Código A-Z',
    'code,DESC': 'Código Z-A',
    'created_at,DESC': 'Más recientes',
    'created_at,ASC': 'Más viejos',
};

const OrdersCreateFiltersForm = ({ setFilters, filters }) => {

    const [categoryTitle, setCategoryTitle] = useState('Categorías');
    const [categoryImage, setCategoryImage] = useState(null);
    const [showMenuCategories, setShowMenuCategories] = useState(false);

    const [categoriesFilters, setCategoriesFilters] = useState({
        page: 1,
        parentsOnly: true,
        orderBy: 'name,ASC',
        with: ['childrens.childrens']
    });

    const [{ categories, loading: loadingCategories }] = useCategories({ params: { ...categoriesFilters } });

    useEffect(() => {
        setFilters((oldFilters) => {
            return {
                ...oldFilters,
                subCategoryId: '',
                grandsonCategoryId: '',
                page: 1
            }
        });
    }, [filters.categoryId])

    useEffect(() => {
        setFilters((oldFilters) => {
            return {
                ...oldFilters,
                grandsonCategoryId: '',
                page: 1
            }
        });
    }, [filters.subCategoryId])

    const handleCategory = (category) => {
        setCategoryTitle(category?.name || 'Categorías');
        setCategoryImage(category?.image_path || null);
        setFilters(oldFilters => ({ ...oldFilters, page: 1, categoryId: category?.id || '' }));
    }

    return (
        <div className="col-md-12 mb-3">
            <div className="row">
                <div className="col-md-3 mb-3 position-relative">
                    <button className="btn d-flex btn-primary align-items-center w-100" type="button" onClick={() => setShowMenuCategories(old => !old)}>
                        <div>
                            <MdDashboard />
                            {categoryTitle}
                        </div>
                        {
                            showMenuCategories ?
                                <FaArrowUp style={{ marginLeft: 'auto' }} />
                                :
                                <FaArrowDown style={{ marginLeft: 'auto' }} />
                        }
                    </button>
                </div>
                <div className="col-md-3 mb-3 position-relative">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Nombre..."
                        onChange={(e) => setFilters((old) => ({ ...old, name: e.target.value, page: 1 }))}
                    />
                </div>
                <div className="col-md-3 mb-3 position-relative">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Código..."
                        onChange={(e) => setFilters((old) => ({ ...old, code: e.target.value, page: 1 }))}
                    />
                </div>
                <div className="col-md-3 mb-3 position-relative">
                    <Dropdown style={{ width: '100%' }}>
                        <Dropdown.Toggle style={{ width: '100%', textAlign: 'left' }} variant="primary" id="dropdown-basic">
                            Ordernar por: {orderByObject[filters?.orderBy]}
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            {
                                Object.keys(orderByObject).map((key, i) => {
                                    return (
                                        <Dropdown.Item onClick={() => setFilters((old) => ({ ...old, orderBy: key, page: 1 }))}>
                                            {orderByObject[key]}
                                        </Dropdown.Item>
                                    )
                                })
                            }
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            </div>
            {
                showMenuCategories ?
                    loadingCategories ?
                        <div className="spinner-border text-primary" role="status" style={{ width: 60, height: 60 }}>
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        :
                        <div className="row animate__animated animate__fadeInLeft">
                            {/* COLUMNA IZQUIERDA (LISTA DE BOTONES) */}
                            <div className="col-4">
                                <div className="list-group" id="list-tab" role="tablist" style={{ maxHeight: 500, minHeight: 500, overflow: 'auto' }}>
                                    <button
                                        type="button"
                                        className={clsx(["list-group-item list-group-item-action"], { 'active': !filters?.categoryId })}
                                        onClick={() => handleCategory(null)}
                                    >
                                        Todas
                                    </button>
                                    {
                                        categories?.map((category, i) => {
                                            return (
                                                <button
                                                    key={`categoty-button-${category?.id}`}
                                                    type="button"
                                                    className={clsx(["list-group-item list-group-item-action"], { 'active': filters?.categoryId == category?.id })}
                                                    id={`category-button-${category?.id}`}
                                                    onClick={() => handleCategory(category)}
                                                >
                                                    {category?.name}
                                                </button>
                                            )
                                        })
                                    }
                                </div>
                            </div>

                            {/* COLUMNA DERECHA (CONTENIDO DEL RECUADRO GRIS) */}
                            <div className="col-8">
                                <div className="tab-content">
                                    {
                                        categories?.map((category, i) => {
                                            return (
                                                <div
                                                    key={`categories-container-${category?.id}`}
                                                    style={{ background: 'whitesmoke', minHeight: 500 }} // Ajusté minHeight
                                                    className={clsx(["rounded animate__animated animate__fadeInUp p-3 tab-pane fade "], { "show active": filters?.categoryId == category?.id })}
                                                    id={`category-children-container-${category?.id}`}
                                                    role="tabpanel"
                                                >

                                                    <div className="w-100 mb-4 rounded overflow-hidden shadow-sm" style={{ position: 'relative', height: '180px' }}>
                                                        <img
                                                            src={categoryImage}
                                                            alt={categoryTitle}
                                                            className="w-100 h-100"
                                                            style={{ objectFit: 'cover', objectPosition: 'center' }}
                                                        />
                                                        {/* Título sobre la imagen */}
                                                        <div style={{
                                                            position: 'absolute', bottom: 0, left: 0, width: '100%',
                                                            background: 'linear-gradient(to top, rgba(0,0,0,0.7), transparent)',
                                                            padding: '15px', color: 'white'
                                                        }}>
                                                            <h3 className="m-0 text-white fw-bold">{categoryTitle}</h3>
                                                        </div>
                                                    </div>


                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <h4 className="mb-3">
                                                            {category?.name}
                                                        </h4>
                                                    </div>

                                                    <div className="row">
                                                        {
                                                            category?.children?.map((childCategory, i) => {
                                                                return (
                                                                    <div className="col-md-3 mb-3" key={`child-category-${childCategory?.id}`}>
                                                                        <div className="d-flex">
                                                                            {
                                                                                filters?.subCategoryId == childCategory?.id ?
                                                                                    <span style={{ cursor: 'pointer' }} onClick={() => setFilters((old) => ({ ...old, subCategoryId: '', page: 1 }))}>❌</span>
                                                                                    :
                                                                                    null
                                                                            }
                                                                            <button
                                                                                onClick={() => setFilters(old => ({ ...old, subCategoryId: childCategory?.id, page: 1 }))}
                                                                                type="button"
                                                                                className={clsx({ "link-dark bg-transparent text-capitalize": filters?.subCategoryId !== childCategory?.id, "text-primary": filters?.subCategoryId == childCategory?.id })}
                                                                                style={{ border: 'none', textAlign: 'left' }}
                                                                            >
                                                                                <b>
                                                                                    {childCategory?.name}
                                                                                </b>
                                                                            </button>
                                                                        </div>

                                                                        <ul style={{ marginLeft: 10 }}>
                                                                            {
                                                                                childCategory?.children?.map((grandsonCategory, i) => {
                                                                                    return (
                                                                                        <li
                                                                                            key={`grandson-category-${grandsonCategory?.id}`}
                                                                                            className="d-flex align-items-center gap-2"
                                                                                        >
                                                                                            {
                                                                                                grandsonCategory?.id == filters?.grandsonCategoryId ?
                                                                                                    <span style={{ cursor: 'pointer' }} onClick={() => setFilters((old) => ({ ...old, grandsonCategoryId: '', page: 1 }))}>❌</span>
                                                                                                    :
                                                                                                    '- '
                                                                                            }
                                                                                            <div
                                                                                                className={clsx("grandson-category text-capitalize", {
                                                                                                    "text-primary": grandsonCategory?.id == filters?.grandsonCategoryId
                                                                                                })}
                                                                                                onClick={() => setFilters(old => ({ ...old, grandsonCategoryId: grandsonCategory?.id, page: 1 }))}
                                                                                            >
                                                                                                {grandsonCategory?.name}
                                                                                            </div>
                                                                                        </li>
                                                                                    )
                                                                                })
                                                                            }
                                                                        </ul>
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                    :
                    null
            }
        </div >
    )
}

export default OrdersCreateFiltersForm;